var React = require('react');

function NavbarLaptop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m624 416h-242.46c-.74 19.81-14.71 32-32.74 32h-60.8c-18.69 0-33.02-17.47-32.77-32h-239.23c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zm-48-368c0-26.4-21.6-48-48-48h-416c-26.4 0-48 21.6-48 48v336h512zm-64 272h-384v-256h384z"}));
}

NavbarLaptop.defaultProps = {"height":"512","viewBox":"0 0 640 512","width":"640"};

module.exports = NavbarLaptop;

NavbarLaptop.default = NavbarLaptop;
